import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
interface OrderBumpProps {
  isChecked: boolean;
  onToggle: () => void;
}
export function OrderBump({
  isChecked,
  onToggle
}: OrderBumpProps) {
  return <div className="max-w-4xl mx-auto my-12" data-id="element-410">
      <motion.div whileHover={{
      scale: 1.005
    }} className={`border-2 rounded-3xl overflow-hidden transition-all cursor-pointer relative bg-cream-light ${isChecked ? 'border-gold bg-gold/10' : 'border-gold animate-border-flash'}`} onClick={onToggle} data-id="element-411">
        {/* Pulsing label */}
        <div className="absolute top-4 left-4 z-20 bg-gold text-charcoal text-[10px] uppercase tracking-widest font-bold px-3 py-1.5 rounded-full shadow-lg" data-id="element-412">
          ⚡ Oferta Única — Solo Hoy
        </div>

        <div className="grid md:grid-cols-[1fr_1.2fr] gap-0" data-id="element-413">
          {/* Square 1:1 image */}
          <div className="aspect-square w-full overflow-hidden bg-cream-dark" data-id="element-414">
            <img src="https://cdn.magicpatterns.com/uploads/1mVrRURW6fjS5nj3jtn2zi/PORTADA_DE_ORDER_BUMP.png" alt="Rituales de Bienestar - Order Bump" className="w-full h-full object-cover" data-id="element-415" />
          </div>

          {/* Content */}
          <div className="p-8 md:p-10 flex flex-col justify-center relative z-10" data-id="element-416">
            <div className="flex items-start gap-4" data-id="element-417">
              {/* High-contrast checkbox */}
              <div className="mt-1 shrink-0" data-id="element-418">
                <div className={`w-8 h-8 rounded-lg border-2 flex items-center justify-center transition-all shadow-md ${isChecked ? 'bg-olive border-olive-deep scale-110' : 'bg-white border-olive-deep ring-2 ring-gold/40 ring-offset-2 ring-offset-cream-light'}`} data-id="element-419">
                  {isChecked && <Check className="w-5 h-5 text-gold" strokeWidth={3} data-id="element-420" />}
                </div>
              </div>

              <div className="flex-grow" data-id="element-421">
                <p className="text-xs uppercase tracking-widest text-gold font-bold mb-3" data-id="element-422">
                  Sumá los Rituales de Bienestar
                </p>

                <h3 className="text-2xl font-serif text-charcoal mb-4 leading-snug" data-id="element-423">
                  Sí, quiero agregar los{' '}
                  <span className="italic text-olive" data-id="element-424">
                    Rituales de Bienestar
                  </span>
                </h3>

                <div className="space-y-4 text-sm text-charcoal-light font-light leading-relaxed mb-6" data-id="element-425">
                  <p data-id="element-426">
                    2 audios exclusivos diseñados por psicólogas para regular tu
                    sistema nervioso, reducir el cortisol y restaurar tu
                    energía.
                  </p>
                  <ul className="space-y-2 pl-4 border-l border-gold/30" data-id="element-427">
                    <li data-id="element-428">
                      <strong className="font-medium text-charcoal" data-id="element-429">
                        Ritual Matutino (15 min):
                      </strong>{' '}
                      Activá tu día con intención y vitalidad.
                    </li>
                    <li data-id="element-430">
                      <strong className="font-medium text-charcoal" data-id="element-431">
                        Ritual Nocturno (12 min):
                      </strong>{' '}
                      Desactivá el estrés y prepará tu cuerpo para sueño
                      profundo.
                    </li>
                  </ul>
                </div>

                <div className="flex items-center gap-3 pt-5 border-t border-gold/20 flex-wrap" data-id="element-432">
                  <p className="text-charcoal-light text-sm" data-id="element-433">
                    Valor real: <span className="line-through" data-id="element-434">$9.990</span>
                  </p>
                  <p className="font-serif text-2xl text-gold font-bold" data-id="element-435">
                    Ahora $4.990
                  </p>
                  <span className="text-xs font-sans font-light text-charcoal-light" data-id="element-436">
                    (suma a tu compra)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}